import { AuthController } from '@controllers/auth-controller';
import { INVOICES_PARTNER, PARTNER_ROLES } from '@utils/controller-utils';
import { codeSplit } from 'bernie-core';

export class InvoicesController extends AuthController {
  public pageId = INVOICES_PARTNER;
  public path = '/partner/invoices';
  public routeName = 'invoices';
  public bundles = [];
  public pageTitle = 'controllers.invoices';
  public isPartnerView = true;
  public accessRoles = [PARTNER_ROLES.ADVERTISER_ADMIN, PARTNER_ROLES.ADVERTISER_USER, PARTNER_ROLES.ADVERTISER_VIEWER];
  public navIcon = 'payments';

  public component = codeSplit(() => import(/* webpackChunkName: "invoices" */ '../../views/partner/invoices'));
  public exact = true;
}
